var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30001 5.0002L0.700012 2.4002C0.383345 2.08353 0.312679 1.7212 0.488012 1.3132C0.662679 0.904529 0.975012 0.700195 1.42501 0.700195H6.57501C7.02501 0.700195 7.33735 0.904529 7.51201 1.3132C7.68735 1.7212 7.61668 2.08353 7.30001 2.4002L4.70001 5.0002C4.60001 5.1002 4.49168 5.17519 4.37501 5.22519C4.25835 5.2752 4.13335 5.3002 4.00001 5.3002C3.86668 5.3002 3.74168 5.2752 3.62501 5.22519C3.50835 5.17519 3.40001 5.1002 3.30001 5.0002Z",
    fill: "#454954"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow_down_icon.13c2d71d22b6636aa910d7e5a596c993.svg";
export { ForwardRef as ReactComponent };